import type { FC } from 'react';
import { useState } from 'react';
import BottomSheet from '../BottomSheet';
import * as S from './styles';
import { ChevronDownIcon } from '../../../assets/icons/ChevronDownIcon';
import { Text } from '@skin-seoul/design-system';
export interface SelectOption {
  value: string;
  label: string;
}
interface MobileSelectProps {
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
  title?: string;
  showSelectedValue?: boolean;
}
export const MobileSelect: FC<MobileSelectProps> = ({
  options,
  value,
  onChange,
  title = 'Sort',
  showSelectedValue = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedOption = options.find(option => option.value === value);
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);
  const handleSelect = (newValue: string) => {
    onChange(newValue);
    handleClose();
  };
  return <>
      <S.SelectButton onClick={handleOpen} data-sentry-element="S.SelectButton" data-sentry-source-file="MobileSelect.tsx">
        <Text lineClamp={1} data-sentry-element="Text" data-sentry-source-file="MobileSelect.tsx">{showSelectedValue && selectedOption ? selectedOption.label : title}</Text>
        <span>
          <ChevronDownIcon data-sentry-element="ChevronDownIcon" data-sentry-source-file="MobileSelect.tsx" />
        </span>
      </S.SelectButton>

      <BottomSheet isOpen={isOpen} onClose={handleClose} title={title} data-sentry-element="BottomSheet" data-sentry-source-file="MobileSelect.tsx">
        <S.OptionsList data-sentry-element="S.OptionsList" data-sentry-source-file="MobileSelect.tsx">
          {options.map(option => <S.OptionItem key={option.value} isSelected={option.value === value} onClick={() => handleSelect(option.value)} textStyle="paragraph.small" color="neutral.700">
              {option.label}
              {option.value === value && <S.CheckIcon>✓</S.CheckIcon>}
            </S.OptionItem>)}
        </S.OptionsList>
      </BottomSheet>
    </>;
};
export default MobileSelect;